import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { UrlConstants } from 'src/app/models/urlConstants';
import Swal from 'sweetalert2';
import { Account, ClientData } from '../user-profile-details/client-data';
import { ApiService } from 'src/app/services/api.service';
import { BroadcastEventListener, ISignalRConnection, SignalR, SignalRConfiguration } from 'ng2-signalr';
import { ApexNonAxisChartSeries, ApexChart, ApexResponsive, ApexTheme } from 'ng-apexcharts';
import { RequestService } from 'src/app/services/request.service';


interface StockRequest {
  SymbolCode: string;
  RelationCode: string;
  relationClientCode:string;
  Qty: number;
  CustodianCode: number;
  CostPrice: number;
}
export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  theme: ApexTheme;
};

@Component({
  selector: 'app-request-reserve-shares-modal',
  templateUrl: './request-reserve-shares-modal.component.html',
  styleUrls: ['./request-reserve-shares-modal.component.scss']
})
export class RequestReserveSharesModalComponent implements OnInit {
  isSubmitting = false;
  titleMessage: string;
  textConfirmMassage: string;
  @Input() selectedAccount: Account;
  submitStatus;
  accList: Account[]; 
  newReqStock: StockRequest = {} as StockRequest;
  lastExecutionTime: number = 0;
  chartStocks: number;
  purchaseStocks: number;
  branches: any;
  balanceAmount: any;
  noChart: boolean;
  userPortfolio: ClientData;
  isProfileLoading = false;
  Endorsement: string;
  companyName: string;
  public chartOptions: Partial<ChartOptions>;
  allstocks: any;
  allCustod: any;
 userAccounts :  Account[];
  selectedAccountControl = new FormControl(null, Validators.required);
    private subscriptions: any[] = [];



  private portfolioConnection: ISignalRConnection;
  accountList: Account[];
  constructor(    
      public translate: TranslateService,
      private http: HttpClient,
      private apiService: ApiService,
      private requestService: RequestService,
      private signalR: SignalR,
      private router: Router,
    ) { }

  ngOnInit(): void {
    this.accountList = JSON.parse(localStorage.getItem("accList"));
    this.selectedAccount= this.accountList[0];
    this.clientSelected(this.selectedAccount);
    this.fetchUserPortfolio(this.selectedAccount);
    this.fetchSymbolsandCustd();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedAccount && changes.selectedAccount.currentValue) {
      this.clientSelected(changes.selectedAccount.currentValue);
      this.fetchUserPortfolio(changes.selectedAccount.currentValue);
      this.fetchSymbolsandCustd();
    }
  }
  fetchSymbolsandCustd() {
    const sub1 = this.apiService.fetchBOAllSymbols().subscribe((res) => (this.allstocks = res));
    const sub2 = this.apiService.fetchAllCustd().subscribe((arg) => (this.allCustod = arg));

  }
    clientSelected(e: Account) {
         
      // this.apiService.fetchClientAccounts(e.relationCode).subscribe((res) => {
      //   this.userAccounts = res as Account[];
      //   this.accList = res as Account[];
      //   this.initPortfolioSignalR();
      // this.selectedAccountControl.setValue(null);
      // });
      this.userAccounts =   JSON.parse(localStorage.getItem("accList")) as Account[];
      this.initPortfolioSignalR();
      this.selectedAccountControl.setValue(null);
    }

    fetchUserPortfolio(selectedAcc?) {
      if (selectedAcc) this.selectedAccount = selectedAcc;
  
      if (this.selectedAccount != null && this.selectedAccount.relationCode) {
        this.requestService.fetchUserPortfolio(this.selectedAccount.relationCode)
          .subscribe((res) => {
            this.userPortfolio = res as ClientData;
            this.companyName = this.userPortfolio.Profile.CompanyNameAr;
          });
      }
    }
    onAccountChange(relationCode: string) {
      if (!this.userAccounts) {
        return;
      }
    
      const selectedAcc = this.userAccounts.find(acc => acc.relationCode === relationCode);
      if (selectedAcc) {
        this.selectedAccount = selectedAcc; 
        this.fetchUserPortfolio(selectedAcc); 
      }
    }
    

   initPortfolioSignalR() {
       if (this.portfolioConnection != null) this.portfolioConnection.stop();
   
       if (this.selectedAccount.ExchangeCode != null) {
         let config: SignalRConfiguration = new SignalRConfiguration();
         config.url = UrlConstants.backofficeUrl;
         config.hubName = "ordersHub";
         config.logging = false;
   
         this.signalR.connect(config).then((res) => {
           this.portfolioConnection = res;
   
           this.portfolioConnection.invoke(
             "JoinGroup",
             this.selectedAccount.ExchangeCode
           );
   
           let method = new BroadcastEventListener<any>("UpdatePortfolio");
   
           this.portfolioConnection.listen(method);
           method.subscribe((update) => {
             this.refetchClientInfo();
           });
   
           this.portfolioConnection.errors.subscribe((res) => {
             this.initPortfolioSignalR();
           });
         });
       }
     }
   
     refetchClientInfo() {
         if (this.selectedAccount != null && this.selectedAccount.relationCode) {
           const currentTime = Date.now();
           const timeElapsed = currentTime - this.lastExecutionTime;
     
           if (timeElapsed < 5000) {
             return;
           }
     
           // Update the last execution time
           this.lastExecutionTime = currentTime;
     
           this.noChart = null;
           this.isProfileLoading = true;
     
           this.http
             .get(
               `${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${this.selectedAccount.relationCode}`
             )
             .subscribe((res) => {
               this.isProfileLoading = false;
               this.userPortfolio = res as ClientData;
     
               this.companyName = this.userPortfolio.Profile.CompanyNameAr;
     
               this.Endorsement = `الساده شركة ${this.companyName} برجاء التكرم بفتح حد إئتمان للتداول في ذات الجلسة علي حسابي طرف شركتكم  وفي حالة التنفيذ و ظهور مديونية أتعهد أن يتم سداد كامل مديونية اليوم بالبيع أو بالإيداع و في حالة عدم التزامي بإغلاق المديونية قبل نهاية الجلسة بنصف ساعة أفوض الشركة ببيع أي أسهم موجودة بمحفظتي لسداد كامل المديونية وهذا إقرار مني بذلك`;
     
               if (
                 this.ratedActiveBalance == 0 &&
                 this.userPortfolio.Portfolio.RatedPortfolio == null
               )
                 this.noChart = true;
               else if (
                 this.ratedActiveBalance > 0 &&
                 (!this.userPortfolio.Portfolio?.RatedPortfolio ||
                   this.userPortfolio.Portfolio?.RatedPortfolio?.TotalMarketValue ==
                   0)
               ) {
                 this.purchaseStocks = 100;
                 this.chartStocks = 0;
                 this.initChart();
               } else if (
                 this.ratedActiveBalance <= 0 &&
                 this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue > 0
               ) {
                 this.purchaseStocks = 0;
                 this.chartStocks = 100;
                 this.initChart();
               } else if (this.userPortfolio.Portfolio.RatedPortfolio != null) {
                 this.chartStocks =
                   (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue /
                     (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
                       this.ratedActiveBalance)) *
                   100;
                 this.purchaseStocks =
                   (this.ratedActiveBalance /
                     (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
                       this.ratedActiveBalance)) *
                   100;
                 this.initChart();
               }
             });
         } else this.portfolioConnection.stop();
       }

       get ratedActiveBalance() {
        return this.userPortfolio?.PurchasePower?.BlockingAmount?.find(
          (item) => item.curr == "Rated"
        ).activebalance;
      }
      
      initChart() {
        this.chartOptions = {
          series: [this.chartStocks, this.purchaseStocks],
          chart: {
            width: "100%",
            height: "295",
            type: "donut",
          },
          theme: {
            mode: "light",
            palette: "palette7",
          },
          labels: [
            this.translate.instant("stocks"),
            this.translate.instant("cash"),
          ],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        };
      }   

      noDecimal(event) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
        }
        return true;
      }

   submitReqStock(form: NgForm) {
      this.isSubmitting = true;
      if (form && form.valid) {
        if (this.translate.currentLang == "ar") {
          this.titleMessage = "تأكيد طلب حجز اسهم";
          this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الطلب
       الحساب: ${this.selectedAccount.clientNameAr}   
       كمية: ${form.form.value.Qty}
       امين حفظ: ${form.form.value.CustodianCode.CustodianNameA}
       السهم:  ${form.form.value.SymbolCode.ShortNameA}
       سعر التكلفة: ${form.form.value.CostPrice}`;

        }
        if (this.translate.currentLang == "en") {
          this.titleMessage = "Book Stock Request Confirmation";
          this.textConfirmMassage = `Please check The Information Before Send The Request
        Account: ${this.selectedAccount.clientNameEn}   
        Qty: ${form.form.value.Qty}
        Custodian: ${form.form.value.CustodianCode.CustodianNameE}
        Stock: ${form.form.value.SymbolCode.ShortNameE}
        Cost Price: ${form.form.value.CostPrice}`;
        }
        this.newReqStock.RelationCode = this.selectedAccount.relationCode;
        this.newReqStock.relationClientCode = this.selectedAccount.relationCode;
        this.newReqStock.Qty = form.form.value.Qty;
        this.newReqStock.CustodianCode =
          form.form.value.CustodianCode.CustodianCode;
        this.newReqStock.SymbolCode = form.form.value.SymbolCode.SymbolCode;
        this.newReqStock.CostPrice = form.form.value.CostPrice;
        Swal.fire({
          title: this.titleMessage,
          html: "<pre>" + this.textConfirmMassage + "<pre>",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.translate.instant("yes"),
          cancelButtonText: this.translate.instant("no"),
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.http
              .post(
                UrlConstants.backofficeUrl +
                "/api/OnlineTrading/PostRequestStockBook",
                this.newReqStock
              )
              .subscribe(
                (res) => {
                  this.isSubmitting = false;
                  if (res) this.submitStatus = res;
                  form.resetForm();
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: this.translate.instant("succes-msg"),
                    showConfirmButton: false,
                    timer: 4500,
                  });
                  this.router.navigate(['/requests-analysis/requests-table']);
                },
                (err) => {
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title: this.translate.instant("error-msg"),
                    showConfirmButton: false,
                    timer: 4500,
                  });
                  this.router.navigate(['/requests-analysis/requests-table']);
                }
              );
          } else if (
            /* Read more about handling dismissals below */
            !result.isConfirmed
          ) {
            this.isSubmitting = false;
          }
        });
      }
    }
    ngOnDestroy(): void {
      if (this.portfolioConnection) {
        this.portfolioConnection.stop();
      }
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }

}
